<template>
  <el-input
    ref="input"
    v-model="inputValue"
    :type="type"
    :maxlength="maxlength"
    :minlength="minlength"
    :placeholder="placeholder"
    :readonly="readonly"
    :disabled="disabled"
    :suffix-icon="suffixIcon"
    :prefix-icon="prefixIcon"
    :rows="rows"
    :autofocus="autofocus"
    :clearable="clearable"
    size="small"
    :class="{ 'no-border': noBorder }"
    oninput ="this.type=='number'?(value=value.replace(/[^0-9.]/g,'')):''"
    @input="handleInput"
    @keyup.enter.native="handleEnter"
    @blur="handlerBlur"
    @change="handlerChange"
    @focus="handlerFocus"
    @keydown.native="preventNonNumberInput"
  >
    <template
      v-if="prepend"
      slot="prepend"
    >
      {{ prepend }}
    </template>
    <template
      v-if="append"
      slot="append"

    >
      <span
        class="hand"
        @click="appendEmit">
        {{ append }}
      </span>

    </template>
  </el-input>
</template>
<script>
export default {
  name: 'VInput',
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    maxlength: {
      type: [String, Number],
      default: ''
    },
    minlength: {
      type: [String, Number],
      default: ''
    },
    rows: {
      type: Number,
      default: 2
    },
    readonly: {
      type: Boolean,
      default: false
    },
    prepend: {
      type: String,
      default: ''
    },
    append: {
      type: String,
      default: ''
    },
    suffixIcon: {
      type: String,
      default: ''
    },
    prefixIcon: {
      type: String,
      default: ''
    },
    noBorder: {
      type: Boolean,
      default: false
    },
    max: {
      type: [Number, Object],
      default: null
    },
    min: {
      type: [Number, Object],
      default: null
    },
    int: {
      type: Boolean,
      default: false
    },
    keyNumber: {
      type: Boolean,
      default: false
    },
    keyNonChinese: {
      type: Boolean,
      default: false
    },
    uppercase: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    keyFloatNumber: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      default: 0
    },
    clearable:{
      type: Boolean,
      default: false
    },
    negativeNumber: {
      // 负数
      type: Boolean,
      default: false
    },
    letterAndNumber: {
      // 只能输入字母和数字/
      type: Boolean,
      default: false
    },
    money: {
      type: Boolean,
      default: false
    },
    negativeMoney:{
      // 价钱可以输入负数
      type: Boolean,
      default: false
    },
    integerCount: {
      // 需要多少位整数
      type: [Number, String],
      default: 0
    },
    reg:{
      // 自定义正则
      type: RegExp
    },
    keyAddress: {
      type: Boolean,
      default: false
    },
    keyFloatCount:{
      type: Number,
      default: 2
    }
  },
  data() {
    return {
      inputValue: ''
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        if(val !== this.inputValue) {
          if(this.checkValue(val) || this.checkValue(this.inputValue)) {
            this.inputValue = val
          }

        }
      }
    },
    inputValue: {
      immediate: true,
      handler(val) {
        if(val == null || val === '') {
          this.$emit('input', '')
        }
        else {
          let currentValue = val
          // if(this.type=='number'){
          //   if(typeof currentValue !=='number')
          //     currentValue = currentValue
          //       .replace(/[^\d.]/g, '')
          //       .replace(/^0+/,'0')
          //       .replace(/[e]/g, '')
          //       .replace(/\.{2,}/g, '.')
          //       .replace('.', '$#$')
          //       .replace(/\./g, '')
          //       .replace('$#$', '.')
          //       .replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
          //       .replace(/^\./g, '')
          // }
          if(this.type=='number'&&this.maxlength){
            currentValue = currentValue.length>this.maxlength?currentValue.slice(0,this.maxlength):currentValue
          }
          if(this.keyFloatNumber && !this.negativeNumber){
            if(currentValue){
              currentValue=currentValue.toString().replace(/[^0-9.]/g,'')
              let processedValue = currentValue.toString()
              // 处理多个小数点情况
              const parts = processedValue.split('.')
              if (parts.length > 1) {
                const integerPart = parts[0].replace(/[^\d]/g, '') || '0'
                let decimalPart = parts.slice(1).join('').replace(/[^\d]/g, '')

                // 精确控制小数位数
                decimalPart = decimalPart.substring(0, this.keyFloatCount)
                processedValue = integerPart + '.' + decimalPart
              }
              currentValue = processedValue
            }

          }
          if(this.negativeNumber){
            if(currentValue){
              let reg = this.keyFloatNumber? /[^0-9.-]/g : /[^0-9-]/g
              currentValue=currentValue.toString().replace(reg,'')
            }
          }
          if(this.keyNumber) {
            const pat = /[0-9]/g
            const patResult = currentValue.toString().match(pat)
            currentValue = patResult? patResult.join(''): ''
          }
          if(typeof this.min == 'number' && Number(currentValue) < this.min) {
            currentValue = this.min
          }
          if(typeof this.max == 'number' && Number(currentValue) > this.max) {
            currentValue = this.max
          }
          if(this.int && val !== 0 && val !== '0' && val.toString().indexOf(0) == 0) {
            currentValue = String(currentValue).replace(/\b(0+)/gi, '')
          }

          if(this.uppercase) {
            currentValue = String(currentValue).toUpperCase()
          }
          if(this.keyNonChinese) {
            const pat = /[\u4e00-\u9fa5]/g
            currentValue = String(currentValue).replace(pat, '')
          }
          if(this.letterAndNumber){
            if(currentValue){
              currentValue=currentValue.toString().replace(/[^\w\/]/g,'')
            }
          }
          if(currentValue !== val) {
            this.inputValue = currentValue
          }
          if(this.money){
            if(this.negativeMoney){
              // 只能输入数字和小数点以及负号开头
              // 如果以负号开头则把后面负号都去掉
              if(currentValue.startsWith('-')){
                if(currentValue.lastIndexOf('-') > 0){
                  currentValue = '-' + currentValue.slice(1).toString().replace(/[^\d.]/g, '')
                }else{
                  currentValue=currentValue.toString().replace(/[^\d.-]/g, '')
                }
              }else{
                currentValue=currentValue.toString().replace(/[^\d.]/g, '')
              }
            }else{
              // 只能输入数字和小数点
              currentValue=currentValue.toString().replace(/[^\d.]/g, '')
            }
            // 新增条件：如果 int 为 false，则不允许小数点
            if (this.int) {
              currentValue = currentValue.toString().replace(/\./g, '')
            } else {
              // 去掉多余小数点
              currentValue = currentValue.toString().replace(/\.{2,}/g, '.')
              // 不能以00开头
              currentValue = currentValue.toString().replace(/^00/, '0.')
              // 小数点开头自动补0
              currentValue = currentValue.toString().replace(/^\./g, '0.')
              // 保留两位小数
              currentValue = currentValue.toString().replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
            }
            if (this.int) {
              currentValue = currentValue.toString().replace(/^0+(\d)/, '$1')
            }
          }
          if(this.integerCount > 0){
            // 限制输入几位正整数
            let count = this.integerCount
            currentValue = currentValue.indexOf('.') > 0? currentValue.split('.')[0].substring(0, count) + '.' + currentValue.split('.')[1]: currentValue.substring(0, count)
          }
          if(this.keyAddress){
            const pattern = /[^a-zA-Z0-9\s.\-#']+/g
            currentValue =currentValue.toString().replace(pattern,'')
          }
          if(this.reg){
            currentValue=currentValue.toString().replace(this.reg,'')
          }
          this.$emit('input', currentValue)
        }
      }
    }
  },
  methods: {
    preventNonNumberInput(event) {
      if (!this.keyNumber) return

      // 允许的功能键：退格、删除、Tab、方向键等
      const allowedKeys = [
        'Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight',
        'ArrowUp', 'ArrowDown', 'Home', 'End'
      ]
      if (event.ctrlKey || event.metaKey) return
      // 如果按下了不允许的键，阻止输入
      if (!allowedKeys.includes(event.key) &&
        !/^[0-9]$/.test(event.key) &&
        event.key !== 'Enter') {
        event.preventDefault()
      }
    },
    handleInput(event) {
      this.$emit('input', event)
    },
    handleEnter() {
      this.$emit('keyEnter')
    },
    handlerBlur() {
      this.$emit('blur')
    },
    handlerFocus(){
      this.$emit('focus')
    },
    focus(){
      this.$refs['input'].focus()
    },
    handlerChange() {
      this.$emit('change','',this.index)
    },
    checkValue(value) {
      if(value === '' || value === null) {
        return false
      }
      return true
    },
    appendEmit(){
      this.$emit('handlerAppend')
    }
  }
}
</script>

<style lang="scss" scoped>
    .el-input {
        width: 100%;
        & /deep/ .el-input-group__prepend {
          padding: 0 10px;
        }
        &.no-border /deep/ .el-input__inner {
          border: 0!important;
        }
    }
</style>
<style lang="scss">
input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
    }
    input[type="number"]{
      -moz-appearance: textfield;
    }
.hand{
  cursor:pointer
}
</style>
